export default __webpack_public_path__ + "732d271aa4b7f6215f2fd462a75cfa1e.svg";